import {Link} from "react-router-dom";
import { isAdmin } from "./Authorize";
import CreditPanel from "./CreditPanel";
import Clock from "./Clock";
import React from "react";
import { WalletContext } from "./App";

export default function MainMenu() {
    let wallet = React.useContext(WalletContext);

    return(
        <div style={{paddingTop: '30px', paddingBottom: '20px', backgroundColor: '#270238'}}>
            <div style={{display: 'flex'}}>
                <div>
                    <p className="menuItem">
                        <Link to="/" className="menuLink">GAME&nbsp;LOBBY</Link>
                    </p>
                    <p className="menuItem">
                        <Link to="/history" className="menuLink">RACE&nbsp;HISTORY</Link>
                    </p>
                    <p className="menuItem">
                        <Link to="/leaderboard" className="menuLink">LEADERBOARD</Link>
                    </p>
                    <p className="menuItem">
                        <Link to="/halloffame" className="menuLink">HALL&nbsp;OF&nbsp;FAME</Link>
                    </p>
                    <p className="menuItem">
                        <Link to="/events" className="menuLink">EVENTS</Link>
                    </p>
                    {isAdmin(wallet.key) ?
                        <p className="menuItem">
                            <Link to="/admin" className="menuLink">ADMIN</Link>
                        </p> :
                        <p className="menuItem">
                            <Link to="/howtoplay" className="menuLink">HOW TO PLAY</Link>
                        </p>
                    }
                </div>
                <div style={{width: '60px'}} />
            </div>
            <div style={{height: '25px'}}> </div>
            <Clock/>
            <div style={{height: '5px'}}> </div>
            <CreditPanel/>
        </div>
    );
}
